import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FirmwareRoutingModule } from './firmware-routing.module';
import { FirmwareDialogComponent } from './firmware-dialog/firmware-dialog.component';
import { FirmwaresComponent } from './firmwares/firmwares.component';
import { DemoMaterialModule } from '../demo-material-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { ChartistModule } from 'ng-chartist';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ChartsModule } from 'ng2-charts';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';


@NgModule({
  declarations: [FirmwareDialogComponent, FirmwaresComponent],
  imports: [
    CommonModule,
    FirmwareRoutingModule,   
    DemoMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    NgxDatatableModule,
    FlexLayoutModule,
    RouterModule,
    ChartistModule,
    NgApexchartsModule,
    ChartsModule,
    MatSelectModule,
    MatPaginatorModule,
  ]
})
export class FirmwareModule { }
